import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

const BOOLEAN_OPTIONS = [
  { label: 'True', value: 'true' },
  { label: 'False', value: 'false' },
];

@Component({
  selector: 'tf-boolean-input',
  standalone: true,
  imports: [FormsModule, SelectModule],
  template: `
    <p-select
      [inputId]="inputId()"
      [options]="booleanOptions"
      optionLabel="label"
      optionValue="value"
      [placeholder]="placeholder()"
      [ngModel]="value()"
      (ngModelChange)="valueChange.emit($event)"
      [invalid]="invalid()"
      appendTo="body"
      class="w-full"
    />
  `,
  styles: ':host { display: block; width: 100%; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooleanInputComponent {
  readonly value = input<string>('');
  readonly placeholder = input<string>('');
  readonly inputId = input<string>('tf-boolean-input');
  readonly invalid = input<boolean>(false);
  readonly booleanOptions = BOOLEAN_OPTIONS;
  @Output() readonly valueChange = new EventEmitter<string>();
}
